import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as moment from "moment"
import * as date from "../../booking/helpers/date"
import * as endpoint from "../../booking/constants/Endpoints"
import axios from "axios"
import { hosts } from "./itinerary-module"
import * as cookieHelper from "../../helpers/cookie"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { DateTime } from "luxon"
import { handleEvalTracking } from "../../helpers/tracking"

export class ItineraryTaxfree extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      hidePastSteps: props.hidePastSteps,
      taxfreeOrders: undefined,
      profile: props.profile,
      isLoggedIn: props.isLoggedIn,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
  }

  componentDidMount() {
    if (this.state.profile) {
      this.setState({ isLoggedIn: true }, () => {
        this.setLoginState()
      })
    }
  }

  componentDidUpdate() {
    if (this.state.profile !== this.props.profile) {
      this.setState({ profile: this.props.profile }, () => {
        this.setLoginState()
      })
    }
  }

  setLoginState = () => {
    const cookieToken = cookieHelper.getAccessToken()
    const currentToken = window.localStorage.myAuthToken
    if (!cookieToken) {
      if (currentToken) {
        // session timed out or logout was forced
        delete window.localStorage.myAuthToken
        delete axios.defaults.headers.common["Authorization"]
        this.setState({ taxfreeOrders: undefined })
      }
    } else if (cookieToken !== currentToken || !this.state.taxfreeOrders) {
      // new token arrived or state is not loaded
      window.localStorage.myAuthToken = cookieToken
      axios.defaults.headers.common["Authorization"] = "Bearer " + cookieToken
      if (this.state.profile) this.getTaxfreeOrders()
    }
  }

  getTaxfreeOrders = () => {
    const url =
      endpoint.TAXFREE_ORDERS(hosts, this.state.profile.EmailAddress) +
      "?flightDate=" +
      this.state.flightInfo.EstimatedPublicTime +
      "&leadTime=" +
      this.props.block.taxfreeHoursBeforeFlight
    axios
      .get(url)
      .then((res) => res.data)
      .then(
        (result) => {
          this.setState({
            taxfreeOrders: result,
          })
        },
        (error) => {
          this.setState({
            error,
          })
        },
      )
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasAccodionContentBlocks = this.props.block.contentArea?.length > 0

    let buttonLink = this.props.block.buttonLink
    if (this.props.block.linkToAirlineBool) buttonLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    if (this.props.block.buttonAddParkingQueryString) {
      const ROUNDING = 30 * 60 * 1000 /*ms*/
      const dtLocale = date.luxonLocale(this.state.flightInfo.language)
      const zone = "Europe/Copenhagen"
      const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
      const flightInfoDate = estimatedPublicTime.minus({ minutes: this.props.checkInOpens }).minus({ minutes: 60 })
      const roundedDate = DateTime.fromMillis(Math.round(+flightInfoDate.toMillis() / ROUNDING) * ROUNDING)
        .setLocale(dtLocale)
        .setZone(zone)
      buttonLink += `?ad=${roundedDate.toFormat("yyyy-MM-dd")}&at=${roundedDate.toFormat("HH")}:00` // floor to the hour
    }

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return this.state.taxfreeOrders && this.state.taxfreeOrders.length > 0 ? (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem ${theme ? theme : ""} foldable`}
      >
        <div
          className={"departure-info__essentials__detailitems__detailitem__header pointer"}
          onClick={(e) => this.showHideContent(e, ".contentWrapper")}
        >
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </div>
        <div className={"contentWrapper show-hide"}>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={buttonLink}
                    onClick={() => handleEvalTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {this.state.taxfreeOrders.map((order, i) => {
            var pickup = order.subOrders[0].pickup
            var pickupDate = pickup.pickupAfter
            var pickupInterval = pickup.pickupLocation.pickupTimeInterval
            let orderstatusPageLink = this.props.block.shopOrderstatusPage + "?oid=" + order.mainOrderId
            return (
              <React.Fragment key={i}>
                <div className="tablediv">
                  <div className="tablediv__row">
                    <div className="tablediv__row__cell bold">{this.props.block.orderstatusLabel || "Ordrestatus"}</div>
                    <div className="tablediv__row__cell">{order.mainOrderStatus}</div>
                  </div>
                  <div className="tablediv__row">
                    <div className="tablediv__row__cell bold">{this.props.block.pickupLocationLabel || "Afhentningssted"}</div>
                    <div className="tablediv__row__cell">
                      {pickup.pickupLocation.name}, {pickup.pickupLocation.location}
                    </div>
                  </div>
                  <div className="tablediv__row">
                    <div className="tablediv__row__cell bold">{this.props.block.pickupTimeLabel || "Tidspunkt for afhentning"}</div>
                    <div className="tablediv__row__cell">
                      {date.formatDate(pickupDate, "Do MMM YYYY", this.state.flightInfo.language)} (
                      {date.formatDate(pickupDate, "hh:mm", this.state.flightInfo.language)}-
                      {date.formatDate(moment(pickupDate).add(pickupInterval, "minutes"), "hh:mm", this.state.flightInfo.language)})
                    </div>
                  </div>
                </div>
                <div className="textbuttoncontainer">
                  <span className="rich-text"></span>
                  {this.state.block.showMoreButtonText && this.state.block.shopOrderstatusPage ? (
                    <div className="cta-button">
                      <a
                        className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                          buttonColor ? buttonColor : "casc-blue"
                        }`}
                        href={orderstatusPageLink}
                        onClick={() => handleEvalTracking(this.props.block.showMoreButtonTracking)}
                      >
                        <span className="text">{this.props.block.showMoreButtonText}</span>
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </React.Fragment>
            )
          })}
          {hasAccodionContentBlocks ? this.renderContentBlocks(this.props.block.contentArea) : ""}
        </div>
      </div>
    ) : (
      ""
    )
  }
}
